import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  BlockText,
  CircularLoader,
  GridContainer,
  useAsyncCall,
  ViewDialog,
  HtmlParseText,
} from "@duosoftbg/nacid-components";
import { getEmailNotification } from "../../../../../../axios/api/services";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/emailNotificationsControl";

const ViewEmailNotificationDialog = () => {
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();
  const { t } = useTranslation();
  const [notification, setNotification] = useState(null);

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.emailNotificationsControl.modals.view;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "view" }));
  };

  useEffect(() => {
    if (open && id != null) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: getEmailNotification(id),
        onSuccess: (response) => {
          setNotification(response);
        },
        onError: () => {
          //TODO Error message
          setNotification(null);
        },
      };
      asyncCall(asyncCallArgs);
    }
    // eslint-disable-next-line
  }, [id, open]);

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.email.notification.view.dialog"}>
      {!notification && <CircularLoader />}
      {notification && (
        <Fragment key={notification.id + " content"}>
          <GridContainer spacing={4}>
            <BlockText withGrid label={"l.email.notification.id"} text={notification.id} />
            {notification.subject && (
              <BlockText withGrid label={"l.email.notification.subject"} text={notification.subject} />
            )}
            {notification.recipients && (
              <BlockText withGrid label={"l.email.notification.recipients"} text={notification.recipients} />
            )}
            {notification.replyTo && (
              <BlockText withGrid label={"l.email.notification.replyTo"} text={notification.replyTo} />
            )}
            {notification.cc && <BlockText withGrid label={"l.email.notification.cc"} text={notification.cc} />}
            {notification.bcc && <BlockText withGrid label={"l.email.notification.bcc"} text={notification.bcc} />}
            {notification.createdDate && (
              <BlockText withGrid label={"l.email.notification.createdDate"} text={notification.createdDate} />
            )}
            {notification.sentDate && (
              <BlockText withGrid label={"l.email.notification.sentDate"} text={notification.sentDate} />
            )}
            {notification.skipSending != null && (
              <BlockText
                withGrid
                label={"l.email.notification.skipSending"}
                text={notification.skipSending ? t("l.yes") : t("l.no")}
              />
            )}
            {notification.comment && (
              <BlockText
                withGrid
                propsGrid={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                label={"l.email.notification.comment"}
                text={notification.comment}
              />
            )}
            {notification.text && !notification.isHtml && (
              <BlockText withGrid label={"l.email.notification.text"} text={notification.text} />
            )}
            {notification.text && notification.isHtml && (
              <HtmlParseText
                withGrid={true}
                propsGrid={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                text={notification.text}
                label={"l.email.notification.text"}
                styleArray={{ pointerEvents: "none" }}
              />
            )}
          </GridContainer>
        </Fragment>
      )}
    </ViewDialog>
  );
};

export default ViewEmailNotificationDialog;
